














import Vue from 'vue'
import ConnTimeDiagram from './ConnTimeDiagram.vue'
import StreamTimeDiagram from './StreamTimeDiagram.vue'
export default {
    name: "connectiontimelinelist",
    computed: {
        traces() {
            return this.$store.state.vissettings.getAllFiles();   
        },
    },
    components: {
        ConnTimeDiagram,
        StreamTimeDiagram
    },
    methods: {
        filteredconns: function(traceid: number) {
            return this.$store.getters.getFilteredConnsInFile(traceid)
        },
        showstreams: function(traceid: number, connid: number){
            return this.$store.state.vissettings.getFile(traceid).getConn(connid).getShowStreams()
        }
    }
}
